import { render } from "./LoginResetPassword.vue?vue&type=template&id=32c8dcb1"
import script from "./LoginResetPassword.vue?vue&type=script&lang=ts"
export * from "./LoginResetPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script